import { IToastNotification } from "./types";
import { diContainer } from "@/di";
import { DITypes } from "@/core/@types/types";

export default function useNotification(): IToastNotification<string> {
  const notification = diContainer.get<IToastNotification<string>>(
    DITypes.NOTIFICATION
  );

  const showNotification = (
    message: string,
    options?: Record<string, string>
  ) => {
    return notification.showNotification(message, options);
  };

  const showHtmlNotification = (
    message: string,
    options?: Record<string, string>
  ) => {
    return notification.showNotification(message, options);
  };

  const updateNotification = (
    toastId: string,
    options: Record<string, string>
  ) => {
    return notification.updateNotification(toastId, options);
  };

  const closeAll = () => {
    return notification.closeAll();
  };

  return {
    closeNotification: notification.closeNotification,
    showHtmlNotification,
    showNotification,
    updateNotification,
    closeAll
  };
}
